import { render, staticRenderFns } from "./QuoteSummary.vue?vue&type=template&id=45c47b77&scoped=true"
import script from "./QuoteSummary.vue?vue&type=script&lang=js"
export * from "./QuoteSummary.vue?vue&type=script&lang=js"
import style0 from "./QuoteSummary.vue?vue&type=style&index=0&id=45c47b77&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c47b77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c47b77')) {
      api.createRecord('45c47b77', component.options)
    } else {
      api.reload('45c47b77', component.options)
    }
    module.hot.accept("./QuoteSummary.vue?vue&type=template&id=45c47b77&scoped=true", function () {
      api.rerender('45c47b77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteSummary.vue"
export default component.exports